var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4c5664"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m2.66675 5.33335h7.99995 10.6667 2.6667 5.3333v24.00005h-26.66665zm2.66666 21.33335v-13.3333-2.6667-2.66668h21.33329v2.66668 2.6667 13.3333z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.00008 2.66669v2.66666h2.66662v-2.66666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.3334 2.66669v2.66666h2.6667v-2.66666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.33341 13.3334h21.33329v-2.6667h-21.33329z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.33342 18.6667v-2.6667h2.66668v2.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.33342 24v-2.6666h2.66668v2.6666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.6667 18.6667v-2.6667h2.6667v2.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.6667 24v-2.6666h2.6667v2.6666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.0001 18.6667v-2.6667h2.6666v2.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.0001 24v-2.6666h2.6666v2.6666z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.c8ac755fdc7a44c32deab2390f007005.svg";
export { ForwardRef as ReactComponent };